import { getAccessToken } from '../../auth/tokenStore/getAccessToken';

export const getAuthorization = () => {
	const accessToken = getAccessToken() ?? '';

	return `Bearer ${accessToken}`;
};
